import { createFileRoute } from '@tanstack/react-router';
import { McpEndpointCard } from '@/components/integrations/mcp-endpoint-card';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/access/mcp',
)({
  component: () => (
    <PageContent>
      <McpEndpointCard />
    </PageContent>
  ),
});
